'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/react-dom/index.js
 ** module id = 258
 ** module chunks = 2
 **/